import { render, staticRenderFns } from "./TopicMajor.vue?vue&type=template&id=e589a40a&scoped=true&"
import script from "./TopicMajor.vue?vue&type=script&lang=js&"
export * from "./TopicMajor.vue?vue&type=script&lang=js&"
import style0 from "./TopicMajor.vue?vue&type=style&index=0&id=e589a40a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e589a40a",
  null
  
)

export default component.exports